module.exports = __webpack_public_path__ + "img/esigne1.9542c0a6.png";